import React from 'react';

const ServiceWorkTab = ({ serviceForm, addListItem, updateListItem, removeListItem }) => (
  <div className="space-y-4">
    <div>
      <div className="flex justify-between items-center mb-2">
        <h4 className="font-medium">Комплекс работ (RU)</h4>
        <button
          type="button"
          onClick={() => addListItem('work_complex_ru')}
          className="text-sm text-orange-600"
          data-testid="add-work-complex-btn"
        >
          + Добавить
        </button>
      </div>
      {serviceForm.work_complex_ru.map((item, idx) => (
        <div key={idx} className="flex gap-2 mb-2">
          <span className="w-6 h-8 flex items-center justify-center bg-orange-100 text-orange-600 rounded text-sm">
            {idx + 1}
          </span>
          <input
            type="text"
            value={item}
            onChange={(e) => updateListItem('work_complex_ru', idx, e.target.value)}
            className="flex-1 px-3 py-1.5 border rounded-lg text-sm"
          />
          <button
            type="button"
            onClick={() => removeListItem('work_complex_ru', idx)}
            className="text-red-500 px-2"
            data-testid={`remove-work-complex-${idx}`}
          >
            ×
          </button>
        </div>
      ))}
    </div>

    <div className="border-t pt-4">
      <div className="flex justify-between items-center mb-2">
        <h4 className="font-medium">Необходимые документы (RU)</h4>
        <button
          type="button"
          onClick={() => addListItem('required_docs_ru')}
          className="text-sm text-orange-600"
          data-testid="add-required-docs-btn"
        >
          + Добавить
        </button>
      </div>
      {serviceForm.required_docs_ru.map((item, idx) => (
        <div key={idx} className="flex gap-2 mb-2">
          <input
            type="text"
            value={item}
            onChange={(e) => updateListItem('required_docs_ru', idx, e.target.value)}
            className="flex-1 px-3 py-1.5 border rounded-lg text-sm"
          />
          <button
            type="button"
            onClick={() => removeListItem('required_docs_ru', idx)}
            className="text-red-500 px-2"
            data-testid={`remove-required-docs-${idx}`}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  </div>
);

export default ServiceWorkTab;
